export const inr = (n) => {
  const v = Number(n || 0);
  return "\u20b9" + v.toLocaleString("en-IN", { maximumFractionDigits: 0 });
};

export const inr2 = (n) => {
  const v = Number(n || 0);
  return "\u20b9" + v.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const fmtDate = (s) => {
  if (!s) return "-";
  const d = new Date(s.length <= 10 ? s + "T00:00:00" : s);
  if (isNaN(d)) return s;
  return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
};

export const fmtDateTime = (s) => {
  if (!s) return "-";
  const d = new Date(s);
  if (isNaN(d)) return s;
  return d.toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
};

export const fmtTime = (s) => {
  if (!s) return "-";
  const d = new Date(s);
  if (isNaN(d)) return s;
  return d.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" });
};

export const todayIST = () => {
  const now = new Date();
  const ist = new Date(now.toLocaleString("en-US", { timeZone: "Asia/Kolkata" }));
  return `${ist.getFullYear()}-${String(ist.getMonth() + 1).padStart(2, "0")}-${String(ist.getDate()).padStart(2, "0")}`;
};

export const currentMonthIST = () => todayIST().slice(0, 7);

const cleanPhone = (p) => (p || "").replace(/[^0-9]/g, "").replace(/^0+/, "");

export const telLink = (phone) => `tel:${phone}`;

export const waLink = (phone, message = "") => {
  let p = cleanPhone(phone);
  if (p.length === 10) p = "91" + p;
  return `https://wa.me/${p}${message ? `?text=${encodeURIComponent(message)}` : ""}`;
};

export const mapsLink = (patient) => {
  if (patient?.google_maps_url) return patient.google_maps_url;
  const q = encodeURIComponent([patient?.address, patient?.locality, patient?.city].filter(Boolean).join(", ") || "Ranchi");
  return `https://www.google.com/maps/search/?api=1&query=${q}`;
};

export const initials = (name) =>
  (name || "?").split(" ").map((w) => w[0]).slice(0, 2).join("").toUpperCase();

export const fillTemplate = (msg, patient, extra = {}) =>
  (msg || "")
    .replace(/\{name\}/g, (patient?.name || patient?.patient_name || "").split(" ")[0] || "")
    .replace(/\{review_url\}/g, extra.review_url || "")
    .replace(/\{full_name\}/g, patient?.name || "");
